import React from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useInvoiceDetailsDialog from '../../hooks/dialogs/useInvoiceDetailsDialog';
import InvoiceDetailsWrapper from '../invoiceDetails/InvoiceDetailsWrapper';

const InvoiceDetailsDialog: React.FC<{ open: boolean }> = (props) => {
    const invoiceDetailsDialog = useInvoiceDetailsDialog();

    if (!props.open) {
        return <></>;
    }

    return (
        <>
            <Dialog
                open={props.open}
                onClose={invoiceDetailsDialog.closeDialog}
                maxWidth={'lg'}
                fullWidth
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    <CloseIcon
                        sx={{ cursor: 'pointer' }}
                        onClick={invoiceDetailsDialog.closeDialog}
                    />
                </DialogTitle>
                <InvoiceDetailsWrapper />
            </Dialog>
        </>
    );
};

export default InvoiceDetailsDialog;
